import { useMemo } from "react";
import { ExploreCustomField } from "@/v2/entities/explore/Explore.model";
import { useExploreConversationCustomFields } from "./useExploreConversationCustomFields";
import { useExploreTenantConversationCustomFields } from "./useExploreTenantConversationCustomFields";

function mergeConversationCustomFieldsById(
  ...fieldGroups: ExploreCustomField[][]
): ExploreCustomField[] {
  const byId = new Map<string, ExploreCustomField>();

  for (const fields of fieldGroups) {
    for (const field of fields) {
      byId.set(field.id, field);
    }
  }

  return Array.from(byId.values());
}

export function useExploreConversationCustomFieldsForView(): ExploreCustomField[] {
  const conversationCustomFields = useExploreConversationCustomFields();
  const tenantConversationCustomFields =
    useExploreTenantConversationCustomFields();

  return useMemo(
    () =>
      mergeConversationCustomFieldsById(
        conversationCustomFields,
        tenantConversationCustomFields
      ),
    [conversationCustomFields, tenantConversationCustomFields]
  );
}
